import { configureStore } from '@reduxjs/toolkit';

import companiesReducer from './companiesSlice';
import companyIdentifiersReducer from './companyIdentifiersSlice';
import dataExchangesReducer from './dataExchangesSlice';

const store = configureStore({
  reducer: {
    companies: companiesReducer,
    companyIdentifiers: companyIdentifiersReducer,
    dataExchanges: dataExchangesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
